module.exports = __webpack_public_path__ + "static/media/hwc_logo.768f4376.svg";